/* =====================================================================
 * chatRenderPrefetch — 최근 항목 클릭 전 렌더 청크 선로딩
 * ===================================================================== */

let prefetchPromise: Promise<void> | null = null;

export function prefetchChatRenderModules(): void {
  if (prefetchPromise) return;

  prefetchPromise = Promise.all([
    import('@/components/chat/bubble/MessageBubble'),
    import('@/components/chat/MarkdownRenderer'),
  ])
    .then(() => undefined)
    .catch(() => {
      // 실패 시 다음 기회에 재시도할 수 있도록 잠금 해제
      prefetchPromise = null;
    });
}

